import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white mt-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-xs text-slate-500 shrink-0">
          © {new Date().getFullYear()} Student Hub · Tous droits réservés
        </p>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-600">
          <Link to="/sources-officielles" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-sources">Sources officielles</Link>
          <Link to="/signaler" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-signaler">Signaler une info</Link>
          <Link to="/legal/cgu" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-cgu">CGU</Link>
          <Link to="/legal/confidentialite" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-rgpd">Confidentialité</Link>
          <Link to="/legal/mentions" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-mentions">Mentions légales</Link>
          <Link to="/legal/remboursement" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-refund">Remboursement</Link>
          <Link to="/legal/retractation" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-retract">Rétractation</Link>
          <Link to="/legal/cookies" className="hover:text-slate-900 whitespace-nowrap" data-testid="footer-cookies">Cookies</Link>
        </nav>
      </div>
    </footer>
  );
}
